<template>
    <div>
        <v-data-table
            :loading="this.loading" loading-text="Loading... Please wait"
            :headers="headersBaseAsset"
            :sort-by="['id']"
            :sort-desc="[true]"
            :items="indexedUnit"
            :server-items-length="pagination.count"
            hide-default-footer
            class="full-width">
            <template v-slot:item="row">
                <tr>
                <td>
                    <v-text-field
                        v-model="row.item.name" 
                        :rules="nameRules"
                        :counter="50"
                    ></v-text-field>
                </td>
                <td class="text-left">
                    <v-text-field
                        v-model="row.item.abbreviation" 
                        :rules="abbreRules"
                        :counter="5"
                    ></v-text-field>
                </td>
                <td>
                    <v-btn-toggle>
                        <v-btn small fab @click="save(row.item.id, row.item.name, row.item.abbreviation, row.item.system)"><v-icon>mdi-content-save</v-icon></v-btn>
                            <v-tooltip bottom v-if="row.item.asset_set && row.item.asset_set.length > 0" class="mr-4" >
                            <template v-slot:activator="{ on }">
                                <v-btn small fab ><v-icon color="grey" dark v-on="on">mdi-delete</v-icon></v-btn>
                            </template>
                            <span>These assets have to be removed first: 
                                <ul class="text-left">
                                    <li v-for="(asset, index) in row.item.asset_set" v-bind:key="index">
                                        {{ getAssetName(asset) || "" }} ( ID: {{ asset }} )
                                    </li>    
                                </ul> 
                            </span>
                            </v-tooltip>
                        <v-btn small fab v-if="row.item.asset_set && row.item.asset_set.length == 0" @click="remove(row.item.index, row.item.id)"><v-icon>mdi-delete</v-icon></v-btn>
                    </v-btn-toggle>
                </td>
                </tr>
            </template>
        </v-data-table>
          <div class="text-center">
              <v-pagination class="mt-2 mb-2" v-model="pagination.current" :length="pagination.pages"></v-pagination>
              <div class="subtitle">Total: {{pagination.count}}</div>
          </div>
        <div>
        <p class="caption font-weight-bold">Please save before adding new.</p>
        <v-btn class="mr-4" @click="newBaseAsset()">Add Base Asset</v-btn></div>
    </div>
</template>
<script>
	export default {
        props: {
            systemId: {
                type: Number
            }
        },
		data() {
            return {
                loading: false,
                headersBaseAsset: [
                { text: 'Name', align: 'left', sortable: true, value: 'name', },
                { text: 'Abbreviation', value: 'abbreviation' },
                { text: ''}
                ],
                
                pagination:{
                    count:0,
                    pages: 1,
                    current:1,
                },
                perPage: 20,
                baseAssetList: [],
                assetList: [],
                nameRules: [
                    v => !!v || 'Name is required',
                    v => (v && v.length <= 50) || 'Name must be less than 50 characters',
                ],
                abbreRules: [
                    v => !!v || 'Abbreviation is required',
                    v => (v && v.length <= 5) || 'Abbreviation must be less than 5 characters',
                ],
            }
        },
        computed: {
            indexedUnit () {
                return this.baseAssetList.map((item, index) => ({
                    index: index,
                    ...item
                }))
            },
        },
        methods: {
            list() {
			    this.getBaseAssets(1).then((res) => {
                    this.baseAssetList = res.results;
                    this.pagination.next = res.next
                    this.pagination.count = res.count
                    this.pagination.pages = Math.ceil(res.count / this.perPage)
                });
            },
			async getBaseAssets(page) {
                try {
                    this.loading = true
                    const res = await this.$api.baseAsset.search({ system: this.systemId, limit:this.perPage, offset: this.perPage*(page - 1) })
                    return res.data;
                } catch (error) {
                    // handle error
                } finally {
                    this.loading = false
                }
            },
            save(id, name, abbreviation, system) {
                this.saveBaseAsset(id, name, abbreviation, system).then((res) => {
                    if (res.status == 200 || res.status == 201 ) {
                        this.$swal({
                            icon: 'success',
                            title: 'Saved',
                            reverseButtons: true,
                            confirmButtonText: 'OK',
                        }).then((result) => {
                        })
                        this.list();
                    }
                });
			},
			async saveBaseAsset(id, name, abbreviation, system) {
                try {
                    let res;
                    this.saving = true
                    if (id) {
                        res = await this.$api.baseAsset.save( {id: id, name: name, abbreviation: abbreviation, system: system });
                    } else {
                        res = await this.$api.baseAsset.new({name: name, abbreviation: abbreviation, system: system });
                    }
                    return res;
                } catch (error) {
                    // handle error
                    console.log(error)
                } finally {
                    this.saving = false
                }
            },
            newBaseAsset() {
                this.baseAssetList.push({id: '', name: '', abbreviation: '', system: this.systemId});
            },
            remove(index, id) {
                if (id !== '') {
                    this.$swal({
                        icon: 'warning',
                        title: 'Are you sure to delete this?',
                        showCancelButton: true,
                        reverseButtons: true,
                        confirmButtonText: 'Confirm',
                        cancelButtonText: 'No',
                    }).then((result) => {
                        if (result.value) {
			                this.$api.baseAsset.delete(id).then(res => this.list() );
                        }
                    })
                } else {
                    this.$delete(this.baseAssetList, index)
                }
            },
            getAssetList() {
			    this.getAssets().then(res => this.assetList = res);
            },
			async getAssets() {
                try {
                    const res = await this.$api.asset.list();
                    return res.data;
                } catch (error) {
                    // handle error
                } finally {
                }
            },
            getAssetName(id) {
                if ( this.assetList.length > 0 && id ) {
                    return this.assetList.find(asset => asset.id === id).name;
                }
            },
        },
        mounted(){
            this.list();
            this.getAssets();
        },
        watch: {
            pagination: {
                handler(val){
                    this.getBaseAssets(this.pagination.current).then((res) => {
                        this.assetList = res.results;
                    });
                },
                deep: true
            },
        },
    }
</script>